import React, { Fragment, useEffect, useState } from "react";
import axios from "../../axios";
import { setCookie } from "cookies-next";

const BTCWithdrawalRequestTable: React.FunctionComponent = () => {
  const [requests, setRequests] = useState<any>([]);
  console.log(requests);

  useEffect(() => {
    axios.get("/getBtcWithdrawalRequests").then((res) => {
      setRequests(res.data);
    });
  }, [requests]);
  const deleteRequest = async (id: string, e:React.SyntheticEvent) => {
    e.preventDefault();
    try {
      const res = await axios.delete("/deleteBtcWithdrawalRequest/" + id);
      console.log(res.data);
    } catch (err) {
      console.log("error", err);
    }
  };
  const redemeRequest = async (id: string, e: React.SyntheticEvent, amount: string, _id:string) => {
    let Amount: Number = Number(amount);
    console.log( _id, id , Amount)
    try {
      const res = await axios.put("/redemeBtcWithdrawalRequest/" + id, {
        amount: Amount,
        _id: _id
      });
      // setCookie("user", res.data, { maxAge: 60 * 60 * 2 });
    } catch (err) {}
  };
  console.log(requests)
  const tableData = requests.map((info: any) => {
   
    return (
      <tr>
        <td>{info.username}</td>
        <td>{info.wallet_address}</td>
        <td>${info.amount}</td>
        <td>${info.btc_balance}</td>
        <td>
          <button
            className="btn btn-sm btn-danger mr-1"
            onClick={(e) => deleteRequest(info._id, e)}
          >
            Delete
          </button>
          <button
            className="btn btn-sm btn-success "
            disabled={info.redemed}
            onClick={(e) => redemeRequest(info.id, e, info.amount, info._id)}
          >
            {info.redemed?"Redeemed": "Redeme"}
          </button>
        </td>
      </tr>
    );
  });
  
  return (
    <Fragment>
      <section className="hero-section" style={{ height: "10vh" }}>
        <div className="container">
          <h1 className=" text-center text-white">BTC Withdrawal Requests</h1>
        </div>
      </section>

      <section id="about" className="about-section pt-150 pb-20">
        <div className="container">
          <div className="over-next">
            <table className="table ">
              <thead>
                <tr>
                  <th scope="col">USERNAME</th>
                  <th scope="col">ADDRESS</th>
                  <th scope="col">AMOUNT</th>
                  <th scope="col">BALANCE</th>
                  <th scope="col">ACTIONS</th>
                </tr>
              </thead>
              <tbody>{tableData}</tbody>
            </table>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default BTCWithdrawalRequestTable;
